<template>
    <div id="HomeDiv">
        <HeaderVue isHeader="true"/>
                <!-- BEGIN banner-section -->
        <FooterVue foot= "true" />
    </div>
</template>

<script>
// import Login from '@/components/Login'
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import Vue from 'vue'

export default {
  name: 'Home',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () {
    this.$router.push({ path: '/' })
  },
  created () {
    setTimeout(function () {
      $("#carouselExampleControls").carousel()
      $("#carouselLabPartners").carousel()
    }, 1000)
  },
  data () {
    return {
      onBlurKey: 'none',
      address: '',
      query: this.$localStorage.get('location') ? this.$localStorage.get('location').locationName + '-' + this.$localStorage.get('location').locationZipCode : '',
      items: [],
      selectedLocation: this.$localStorage.get('location') ? this.$localStorage.get('location') : undefined,
      selectedPincode: this.$localStorage.get('pincode') ? this.$localStorage.get('pincode') : undefined,
      locationObj: null
    }
  },
  methods: {
  },
  watch: {
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/web/Dashboard.vue